import axios from 'axios';
import { to } from 'await-to-js';

const {
    REACT_APP_API_URL
} = process.env;

export async function obtenerProductos(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/productos`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function obtenerProducto(id, payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/producto/${id}`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function marcarProductoFavorito(id, payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/producto/${id}/favorito`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function obtenerProductosFavoritos(id) {
    const [error, response] = await to(
        axios.get(`${REACT_APP_API_URL}/tienda-online/productos/favoritos/${id}`)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function registrarPedido(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/pedidos/registrar`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function obtenerPedidosUsuario(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/pedidos/usuario`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function obtenerPedidos() {
    const [error, response] = await to(
        axios.get(`${REACT_APP_API_URL}/tienda-online/pedidos`)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function modificarStatusPedido(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/pedidos/modificar-status`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function cancelarPedido(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/pedidos/cancelar`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function descargarPDFPedido(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/pedidos/generar-pdf`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function obtenerUsuariosTienda() {
    const [error, response] = await to(
        axios.get(`${REACT_APP_API_URL}/tienda-online/usuarios/obtener`)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function rechazarUsuario(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/usuario/rechazar`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function aprobarUsuario(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/usuario/aprobar`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function editarUsuario(id, payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/usuarios/editar/${id}`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function editarListaPreciosUsuario(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/usuario/editar-lista-precios`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function obtenerPromociones() {
    const [error, response] = await to(
        axios.get(`${REACT_APP_API_URL}/tienda-online/promociones`)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function agregarPromocion(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/promociones/agregar`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function editarPromocion(id, payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/promociones/editar/${id}`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function eliminarPromocion(id) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/promociones/eliminar/${id}`)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function obtenerCategorias() {
    const [error, response] = await to(
        axios.get(`${REACT_APP_API_URL}/tienda-online/categorias`)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function agregarCategoria(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/categorias/agregar`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function editarCategoria(id, payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/categorias/editar/${id}`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function eliminarCategoria(id) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/categorias/eliminar/${id}`)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function subirBanner(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/banners/subir`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function obtenerBanners() {
    const [error, response] = await to(
        axios.get(`${REACT_APP_API_URL}/tienda-online/banners`)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function editarBanner(id, payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/banners/editar/${id}`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function eliminarBanner(id) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/banners/eliminar/${id}`)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function subirBannerTienda(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/banners-tienda/subir`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function obtenerBannersTienda() {
    const [error, response] = await to(
        axios.get(`${REACT_APP_API_URL}/tienda-online/banners-tienda`)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function editarBannerTienda(id, payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/banners-tienda/editar/${id}`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function eliminarBannerTienda(id) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/banners-tienda/eliminar/${id}`)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function subirBannerSecundario(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/banners-secundarios/subir`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function obtenerBannersSecundarios() {
    const [error, response] = await to(
        axios.get(`${REACT_APP_API_URL}/tienda-online/banners-secundarios`)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function editarBannerSecundario(id, payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/banners-secundarios/editar/${id}`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function eliminarBannerSecundario(id) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/banners-secundarios/eliminar/${id}`)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function subirProductoDestacado(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/productos-destacados/subir`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function obtenerProductosDestacados() {
    const [error, response] = await to(
        axios.get(`${REACT_APP_API_URL}/tienda-online/productos-destacados`)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function editarProductoDestacado(id, payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/productos-destacados/editar/${id}`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function eliminarProductoDestacado(id) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/productos-destacados/eliminar/${id}`)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function subirCategoriaPresntacion(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/categorias-presentacion/subir`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function obtenerCategoriasPresentacion() {
    const [error, response] = await to(
        axios.get(`${REACT_APP_API_URL}/tienda-online/categorias-presentacion`)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function editarCategoriaPresentacion(id, payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/categorias-presentacion/editar/${id}`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function eliminarCategoriaPresentacion(id, payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/categorias-presentacion/eliminar/${id}`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function subirProductoCategoria(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/categorias-presentacion/subir-producto`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function editarProductoCategoria(id, payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/categorias-presentacion/editar-producto/${id}`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function eliminarProductoCategoria(id, payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/tienda-online/categorias-presentacion/eliminar-producto/${id}`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function enviarCorreo(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/correos/enviar`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}

export async function enviarCorreoNotificacionPedido(payload) {
    const [error, response] = await to(
        axios.post(`${REACT_APP_API_URL}/correos/notificar_pedido`, payload)
    );

    if (error) {
        return []
    }

    return response.data;
}